// Mock the map data
const mapData = [
  {
    name: 'Jawa Barat',
    id: 'JB',
    type: 'province',
    coordinate: {
      lat: -6.918100,
      lng: 107.619122
    },
    link: '/region/detail',
    total: 1,
    markerType: 'organization',
    // This will be used as marker popup content
    metadata: [
      {
        name: 'Headquarter',
        count: 1,
        link: '/region/detail',
        subData: [
          {
            name: 'Government',
            count: 1,
            link: '/region/detail',
          }
        ]
      },
    ],
    // The sub markers
    places: [
      {
        name: 'Bandung',
        id: 'bandung',
        type: 'city',
        coordinate: {
          lat: -6.918100,
          lng: 107.619122,
        },
        total: 2,
        markerType: 'organization',
        metadata: [
          {
            name: 'Kebijakan',
            count: 28,
          },
          {
            name: 'Organisasi',
            count: 7,
          },
          {
            name: 'Inisiatif',
            count: 32,
          },
          {
            name: 'Kasus',
            count: 2,
          }
        ],
      },
    ]
  },
]

export default mapData
